import { Box } from '@mui/material';
import { useFieldHelper } from 'framework/ui/field';
import { openExternalLink } from '../helpers/linkHelpers';
import { splitMessageIntoSegments } from '../helpers/messageHelpers';
import InterruptionMessageLink from './layout/InterruptionMessageLink';
import InterruptionMessageText from './layout/InterruptionMessageText';

type InterruptionMessageProps = {
  source?: string;
  value?: string;
};

const InterruptionMessage = ({ source = 'message', value: inputValue }: InterruptionMessageProps) => {
  const { getValue } = useFieldHelper<string>({ value: inputValue, source });
  const message = getValue() || '';
  const segments = splitMessageIntoSegments(message);
  let segmentOffset = 0;

  return (
    <InterruptionMessageText>
      {segments.map(segment => {
        const segmentStart = message.indexOf(segment.value, segmentOffset);
        segmentOffset = segmentStart + segment.value.length;
        const key = `${segment.isLink ? 'link' : 'text'}-${segmentStart}-${segment.value}`;

        return segment.isLink ? (
          <InterruptionMessageLink
            key={key}
            href={segment.value}
            onClick={event => {
              event.preventDefault();
              openExternalLink(segment.value);
            }}
          >
            {segment.value}
          </InterruptionMessageLink>
        ) : (
          <Box component="span" key={key}>
            {segment.value}
          </Box>
        );
      })}
    </InterruptionMessageText>
  );
};

export default InterruptionMessage;
